import _ from 'lodash'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

const event = (data, headers) => {
	const events = data.map(
		({ id, title, content, categoryName, hour, modified: date, description, link }) => {
			const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
			const images = content.match(regx)

			return {
				id,
				title,
				content,
				description,
				date: format(new Date(date), 'EEEE dd MMMM', { locale: fr }),
				modified: date,
				hour,
				link,
				image: (!_.isEmpty(images) && images[0]) || null,
				categoryName,
			}
		},
	)

	return {
		list: _.sortBy(events, ['modified'], ['asc']),
		infos: { total: headers['x-wp-total'], totalPages: headers['x-wp-totalpages'] },
	}
}

export default event
